<template>
    <v-container>
      <front-navigation></front-navigation>
      <br>
      <!--<v-layout row wrap>-->
        <!--<div class="text-center">-->
          <!--<v-flex lg12 md12 xs12 sm12>-->
            <!--<img :src="singleInventory.thumbnail" alt="">-->
          <!--</v-flex>-->
        <!--</div>-->
      <!--</v-layout>-->
      <v-layout row wrap>
<!--        <v-flex lg12 md12 sm12 xs12 v-if="inventoryImages.length > 0">-->
        <v-flex lg12 md12 sm12 xs12 v-if="inventoryImages">
          <carousel :autoplay="true" :autoplayTimeout="1000" :autoplayHoverPause="true" :perPage="1">
            <slide v-for="(image, key) in inventoryImages" :key="key">
              <img :src="image.path" width="100%" alt="olpejeta activities" >
            </slide>
          </carousel>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12 v-else>
          <img :src="singleInventory.thumbnail" alt="olpejeta activity">
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex lg6 md6 sm12 xs12>
          <div class="container">
            <h3 class="earth-color">{{singleInventory.name}}</h3>
            <h4 style="color: gray; line-height: 1.4444444444444444em !important; font-size: 16px" v-if="singleInventory.ranger_marker === false">Child Price: {{$localCurrency}} {{$roundOff(convert1(singleInventory.price.currency_type, singleInventory.price.child_price).amount)}}</h4>
            <h4 style="color: gray; line-height: 1.4444444444444444em !important; font-size: 16px" v-if="singleInventory.ranger_marker === false">Adult Price: {{$localCurrency}} {{$roundOff(convert1(singleInventory.price.currency_type, singleInventory.price.adult_price).amount)}}</h4>
            <h4 style="color: gray; line-height: 1.4444444444444444em !important; font-size: 16px" v-if="singleInventory.ranger_marker === true">Ranger Price: {{$localCurrency}} {{$roundOff(convert1(singleInventory.price.currency_type, singleInventory.price.adult_price).amount)}} </h4>
            <br>
            <span style="color: gray; line-height: 1.4444444444444444em !important; font-size: 16px" v-html="singleInventory.description"></span>
            <v-dialog v-model="dialog" persistent max-width="600px">
              <v-btn slot="activator" color="primary" large dark>BOOK NOW</v-btn>
              <v-card>
                <v-card-title>
                  <span class="headline">
                    <h4 class="earth-color">BOOKING DATES</h4>
                  </span>
                </v-card-title>
                <v-card-text>
                  <v-tabs
                    color="primary"
                    dark
                    slider-color="primary"
                  >
                    <v-tab  key="conservation">Conservation Fees</v-tab>
                    <v-tab key="availability">Availability</v-tab>
                    <v-tab-item key="conservation">
                      <v-card-text>
                        <div class="row">
                        </div>
                        <h5 style="color: #0c0c0c; font-size: 15px">* If you have already booked conservation fees, click on availability *</h5>
                        <v-flex xs12 sm6 md12>
                          <v-container>
                            <v-dialog
                              ref="dialog"
                              persistent
                              v-model="modal1"
                              lazy
                              full-width
                              width="290px"
                              :return-value.sync="activity.check_in"
                            >
                              <v-text-field
                                slot="activator"
                                label="Check-in *"
                                v-model="activity.check_in"
                                readonly
                                :disabled="activity.activity_date === ''"
                              ></v-text-field>
                              <v-date-picker
                                v-model="activity.check_in"
                                :min="start_date"
                                @input="retrievePricingSchedule()"
                                scrollable>
                                <v-spacer></v-spacer>
                                <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                                <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(activity.check_in)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-container>
                        </v-flex>
                        <v-flex xs12 sm6 md12>
                          <v-container>
                            <br>
                            <v-dialog
                              ref="dialog1"
                              persistent
                              v-model="modal2"
                              lazy
                              full-width
                              width="290px"
                              :return-value.sync="activity.check_out"
                            >
                              <v-text-field
                                slot="activator"
                                label="Check-out *"
                                v-model="activity.check_out"
                                readonly
                                :disabled="activity.activity_date === ''"
                              ></v-text-field>
                              <v-date-picker
                                v-model="activity.check_out"
                                :min="activity.check_in"
                                scrollable>
                                <v-spacer></v-spacer>
                                <v-btn :depressed="true" flat color="primary" @click="modal2 = false">Cancel</v-btn>
                                <v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(activity.check_out)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                            <v-flex lg12 md12 sm12>
                              <v-container>
                                Conservation entry fees
                                <guests></guests>
                              </v-container>
                            </v-flex>
                            <v-flex lg12 md12 sm12>
                              <v-container>
                                Vehicle entry fees
                                <vehicle/>
                              </v-container>
                            </v-flex>
                          </v-container>
                        </v-flex>
                        <small>*indicates required field</small>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary darken-1" flat @click="makeReservation()">Make A Reservation</v-btn>
                      </v-card-actions>
                    </v-tab-item>
                    <v-tab-item key="availability">
                      <v-card flat>
                        <v-card-text>
                          <v-flex xs12 sm6 md12>
                            <v-dialog
                              ref="dialog4"
                              persistent
                              v-model="modal3"
                              lazy
                              full-width
                              width="290px"
                              :return-value.sync="activity.activity_date"
                            >
                              <v-text-field
                                slot="activator"
                                label="Activity Date *"
                                v-model="activity.activity_date"
                                readonly
                                id="activity_date"
                              ></v-text-field>
                              <v-date-picker
                                v-model="activity.activity_date"
                                scrollable
                                :min="start_date"
                                @input="checkAvailability()"
                              >
                                <v-spacer></v-spacer>
                                <v-btn :depressed="true" flat color="primary" @click="modal3 = false">Cancel</v-btn>
                                <v-btn :depressed="true" flat color="primary" @click="$refs.dialog4.save(activity.activity_date)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <div class="row">
                            <v-flex xs6 sm12 md12 v-if="showDates === true || singleInventory.ranger_marker === false">
                              <v-container>
                                <v-autocomplete
                                  label="Children"
                                  :onClick="childSlots_"
                                  :items="childSlots_"
                                  v-model="activity.children"
                                  :disabled="activity.activity_date === ''"
                                  v-if="singleInventory.ranger_marker === false"
                                ></v-autocomplete>
                              </v-container>
                            </v-flex>
                            <v-flex xs6 sm12 md12 v-if="showDates === true || singleInventory.ranger_marker === false">
                              <v-container>
                                <v-autocomplete
                                  label="Adults"
                                  :onClick="adultSlots_"
                                  :items="adultSlots_"
                                  v-model="activity.adults"
                                  :disabled="activity.activity_date === ''"
                                  v-if="singleInventory.ranger_marker === false"
                                ></v-autocomplete>
                              </v-container>
                            </v-flex>
                            <v-flex xs6 sm12 md12 v-if="showDates === true || singleInventory.ranger_marker === true">
                              <v-container>
                                <v-autocomplete
                                  label="No of Rangers"
                                  :onClick="adultSlots_"
                                  :items="adultSlots_"
                                  v-model="activity.adults"
                                  :disabled="activity.activity_date === ''"
                                  v-if="singleInventory.ranger_marker === true"
                                ></v-autocomplete>
                              </v-container>
                            </v-flex>
                            <v-container>
                              <h4>CHECK-IN & CHECK-OUT DATES</h4>
                            </v-container>
                            <v-flex lg6 md6 xs12 sm12>
                              <v-container>
                                <v-dialog
                                  ref="dialogA"
                                  persistent
                                  v-model="modalA"
                                  lazy
                                  full-width
                                  width="290px"
                                  :return-value.sync="activity.check_in"
                                >
                                  <v-text-field
                                    slot="activator"
                                    label="Check-in *"
                                    v-model="activity.check_in"
                                    readonly
                                    :disabled="activity.activity_date === ''"
                                  ></v-text-field>
                                  <v-date-picker
                                    v-model="activity.check_in"
                                    :min="start_date"
                                    scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn :depressed="true" flat color="primary" @click="modalA = false">Cancel</v-btn>
                                    <v-btn :depressed="true" flat color="primary" @click="$refs.dialogA.save(activity.check_in)">OK</v-btn>
                                  </v-date-picker>
                                </v-dialog>
                              </v-container>
                            </v-flex>
                            <v-flex lg6 md6 xs12 sm12>
                              <v-container>
                                <v-dialog
                                  ref="dialogB"
                                  persistent
                                  v-model="modalB"
                                  lazy
                                  full-width
                                  width="290px"
                                  :return-value.sync="activity.check_out"
                                >
                                  <v-text-field
                                    slot="activator"
                                    label="Check-out *"
                                    v-model="activity.check_out"
                                    readonly
                                    :disabled="activity.activity_date === ''"
                                  ></v-text-field>
                                  <v-date-picker
                                    v-model="activity.check_out"
                                    :min="activity.check_in"
                                    scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn :depressed="true" flat color="primary" @click="modalB = false">Cancel</v-btn>
                                    <v-btn :depressed="true" flat color="primary" @click="$refs.dialogB.save(activity.check_out)">OK</v-btn>
                                  </v-date-picker>
                                </v-dialog>
                              </v-container>
                            </v-flex>
                            <v-flex lg6 md6 xs12 sm12 v-if="singleInventory.public_id === '648f6bc6-96bd-446c-89c5-e988749bcdf7'">
                              <v-container>
                                <v-select
                                  :items="['7:00 PM', '9:00 PM']"
                                  label="Select Preferred Time"
                                  v-model="activity.time_frame"
                                ></v-select>
                              </v-container>
                            </v-flex>
                            <v-flex lg6 md6 xs12 sm12 v-if="singleInventory.public_id === '648f6bc6-96bd-446c-89c5-e988749bcdf7' || singleInventory.public_id === '4b45eed6-d1dd-4301-acb5-eca2a682d7c6' || singleInventory.public_id === '66e52cab-43cd-4974-85de-246a731d6905'">
                              <v-container>
                                <v-select
                                  :items="allPickUpLocations"
                                  item-text="location_name"
                                  item-value="location_public_id"
                                  label="Select Pick Up Location"
                                  v-model="activity.pick_up_location"
                                ></v-select>
                              </v-container>
                            </v-flex>
                          </div>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary darken-1" flat @click="makeReservation()">Make A Reservation</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary darken-1" flat @click="dialog = false">Close</v-btn>
                  <!--<v-btn color="primary darken-1" flat @click="checkAvailability() && loadingdialog_ === true" v-if="continue_ === false">{{availabilityButton}}</v-btn>-->
                  <!--<v-btn color="primary darken-1" flat @click="makeReservation()" v-if="continue_ === true">{{bookButton}}</v-btn>-->
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <div class="container-fluid" v-if="booking === true">
            <div class="row">
              <div class="col-md-12">
                <input type="checkbox" class="form-control col-md-2">
                <label class="col-md-10">Park Fees</label>
              </div>
            </div>
          </div>
        </v-flex>
        <!--<v-flex lg6 md6>-->
          <!--<insta-feed></insta-feed>-->
        <!--</v-flex>-->
      </v-layout>
    </v-container>
</template>

<script>
import FrontNavigation from './../Repeated/FrontNavigation'
// import SideBar from '../Repeated/SideBar'
import InstaFeed from '../Repeated/InstaFeed'
import Guests from '../Repeated/Guests'
import Vehicle from '../Repeated/Vehicle'
export default {
  data () {
    return {
      active: false,
      menu1: false,
      modal1: false,
      modalA: false,
      modalB: false,
      menu2: false,
      modal2: false,
      start_date: this.$moment().format('YYYY-MM-DD'),
      adjust: false,
      switch1: true,
      booking: false,
      dialog: false,
      dialogA: false,
      dialogB: false,
      dialog4: false,
      availabiltytab: true,
      modal3: false,
      continue_: false,
      showDates: false,
      loadingdialog_: false,
      totalCount: 0,
      activity: {
        days: 0,
        check_in: '',
        check_out: '',
        currency: localStorage.getItem('currency'),
        activity_date: '',
        children: 0,
        adults: 0,
        inventory: {},
        extra_pax_adults: 0,
        extra_pax_children: 0,
        pick_up_location: '',
        time_frame: ''
      }
    }
  },
  beforeCreate () {
    this.$store.dispatch('get_activity', this.$route.params.activity_id)
    this.$store.dispatch('get_all_pick_up_locations')
    this.$store.dispatch('get_activity_images', this.$route.params.activity_id)
  },
  updated () {
    window.dataLayer = window.dataLayer || []
    var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true
    lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://' + 'www.googletagmanager.com/gtag/js?id=AW-942857980')
    function gtag (){ dataLayer.push(arguments) }
    if (this.singleInventory.length > 0) {
      this.$ga.event(this.singleInventory.google_analytics_code)
      gtag('event', 'conversion', { 'send_to': this.singleInventory.google_analytics_code })
      this.$analytics.fbq.init('429186911200180', {
        em: 'victor.kasii@olpejetaconservancy.org'
      })
      this.$analytics.fbq.event('View Activity', {
        content_name: this.singleInventory.name
      })
    } else {
      this.$ga.event(this.singleInventory.google_analytics_code)
      this.$ga.page(this.singleInventory.google_analytics_code)
      gtag('event', 'conversion', { 'send_to': this.singleInventory.google_analytics_code })
      this.$analytics.fbq.init('429186911200180', {
        em: 'victor.kasii@olpejetaconservancy.org'
      })
      this.$analytics.fbq.event('View Activity', {
        content_name: this.singleInventory.name
      })
    }
  },
  computed: {
    bookButton: function () {
      return 'Make Booking'
    },
    availabilityButton: function () {
      return 'Check Availability'
    },
    childSlots_ () {
      var slots = []
      var available = this.calculateChildMax_
      for (var i = 0; i <= available; i++) {
        slots.push(i)
      }
      return slots
    },
    adultSlots_ () {
      var slots = []
      var available = this.calculateAdultMax_
      for (var i = 0; i <= available; i++) {
        slots.push(i)
      }
      return slots
    },
    calculateAdultMax_: function () {
      return (Number(this.activitySlots) - Number(this.total)) + this.activity.adults
    },
    calculateChildMax_: function () {
      return (Number(this.activitySlots) - Number(this.total)) + this.activity.children
    },
    total: function () {
      return Number(this.activity.adults) + Number(this.activity.children)
    }
  },
  methods: {
    storeVehicles: function () {
      localStorage.setItem('vehicle_data', JSON.stringify(this.allVehicles))
    },
    storeConservation: function () {
      localStorage.setItem('conservation_data', JSON.stringify(this.allConservationFees))
    },
    // make reservation
    makeReservation: function () {
      // Queried in checkAvailability ()
      // TODO: Handle cases when pricing has not been set
      this.activity.inventory.price = this.$store.state.ActivityStore.activity_price_at_time
      if (this.activity.check_in === '' || this.activity.check_out === '') {
        this.$notify({
          type: 'warning',
          group: 'foo',
          title: 'Missing Data',
          text: 'You need a check-in and check-out date to proceed',
          classes: 'alert-wrapper'
        })
      } else {
        var data = {
          public_id: this.activity.inventory.public_id,
          name: this.activity.inventory.name,
          date: this.$moment(this.activity.activity_date).format('YYYY-MM-DD'),
          adults: this.activity.adults,
          adult_price: this.activity.inventory.price.adult_price,
          child_price: this.activity.inventory.price.child_price,
          currency: this.activity.inventory.price.currency_type,
          children: this.activity.children,
          ranger_marker: this.activity.inventory.ranger_marker,
          activity_discount: 0,
          discounts: this.activity.inventory.discount,
          discount_status: this.activity.inventory.discount_status,
          extra_pax_adults: 0,
          extra_pax_children: 0,
          time_frame: this.activity.time_frame,
          pick_up_location: this.activity.pick_up_location
        }
        var oldData = JSON.parse(localStorage.getItem('activity_data'))
        this.$store.commit('CHOSEN_ACTIVITIES', oldData)
        this.$store.commit('ADD_ACTIVITY', data)
        localStorage.setItem('activity_data', JSON.stringify(this.chosenInventory))
        this.activity.inventory = {}
        this.activity.date = ''
        this.activity.adults = 0
        this.activity.children = 0
        this.adjustDates(this.activity.check_in, this.activity.check_out)
        this.storeConservation()
        this.storeVehicles()
        this.$router.push({
          name: 'Reservation'
        })
      }
    },
    checkAvailability () {
      this.activity.inventory = this.$store.state.ActivityStore.activity
      if (this.activity.activity_date === '') {
        this.$notify({
          type: 'warning',
          group: 'foo',
          title: 'Missing Data',
          text: 'You need an activity date to proceed',
          classes: 'alert-wrapper'
        })
      } else {
        this.loadingdialog_ = true
        var data = {
          inventory_id: this.$route.params.activity_id,
          date: this.activity.activity_date
        }
        this.$store.dispatch('check_inventory_availability', data)
        this.continue_ = true
        this.showDates = true
        // Running query for price here. Will be used when adding activity to booking
        var priceData = {
          date: this.$moment(this.activity.activity_date).format('YYYY-MM-DD'),
          public_id: this.$route.params.activity_id
        }
        this.$store.dispatch('get_activity_with_pricing', priceData)
      }
    },
    retrievePricingSchedule: function () {
      let data = {
        check_in_date: this.activity.check_in
      }
      this.$store.dispatch('get_conservation_fee_by_check_in_date', data)
    }
  },
  components: {
    FrontNavigation,
    Guests,
    Vehicle,
    InstaFeed
  }
}
</script>

<style scoped>
  .main-image {
    max-height: 100%;
    max-width: 100%;
  }
  #side {
    /*z-index: 100;*/
    /*margin-top: -10%;*/
    /*position: absolute;*/
    /**/
    background-color: white;
  }
</style>
